import type { MemberAccessRule } from './types.js';

export const RUST_MEMBER_ACCESS_RULES: MemberAccessRule[] = [
  { parentType: 'field_expression', objectField: 'value', propertyField: 'field', tagKind: 'member' },
  { parentType: 'scoped_identifier', objectField: 'path', propertyField: 'name', tagKind: 'member' },
];
